import { Carousel } from "shared/ui/carousel";
import Bragina from "pages/event/assets/Bragina.png";
import Nekrasova from "pages/event/assets/Nekrasova.jpg";
import Paramonov from "pages/event/assets/Paramonov.jpg";
import Kolodiychik from "pages/event/assets/Kolodiychik.png";
import Dagar from "pages/event/assets/Dagar.jpg";
import Romanova from "pages/event/assets/Romanova.jpg";
import Akulova from "pages/event/assets/Akulova.png";
import Razumovskaya from "pages/event/assets/Razumovskaya.jpg";
import Malysheva from "pages/event/assets/Malysheva.jpg";
import styles from "./EventExpertsSection.module.scss";

export const EventExpertsSection = () => {
  const slides = [
    {
      image: Nekrasova,
      text: "Некрасова Светлана Владимировна",
    },
    {
      image: Bragina,
      text: "Брагина Ирина Юрьевна",
    },
    {
      image: Paramonov,
      text: "Парамонов Борис Алексеевич",
    },
    {
      image: Razumovskaya,
      text: "Разумовская Елена Александровна",
    },
    {
      image: Kolodiychik,
      text: "Колодийчик Светлана Михайловна",
    },
    {
      image: Dagar,
      text: "Дагар Алёна Александровна",
    },
    {
      image: Romanova,
      text: "Романова Светлана Борисовна",
    },
    {
      image: Akulova,
      text: "Акулова Наталия Александровна",
    },
    {
      image: Malysheva,
      text: "Малышева Анна Ивановна",
    },
  ];

  return (
    <div className={styles.expertsWrapper}>
      <p className={styles.expertsWrapper__title}>Эксперты</p>
      <Carousel slides={slides} />
    </div>
  );
};
